import { makeStyles } from '@material-ui/core';

const styles = (theme) => ({
  container: {
    maxWidth: 600
  },
  modalHeader: {
    marginBottom: theme.spacing(6),
    fontSize: 32,
    fontWeight: 600,
    lineHeight: 1.2
  },
  section: {
    marginBottom: theme.spacing(6)
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    display: 'block'
  },
  sectionContent: {
    lineHeight: 1.5,
    display: 'block',
    marginBottom: theme.spacing(2)
  },
  list: {
    margin: theme.spacing(2, 0),
    paddingLeft: theme.spacing(5),
    '& li': {
      marginBottom: theme.spacing(2),
      lineHeight: 1.5
    },
    '& li:last-child': {
      marginBottom: 0
    }
  },
  btnContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(8)
  },
  closeBtn: {
    padding: theme.spacing(1.5, 4),
    minWidth: 120
  }
});

export default makeStyles(styles);
